export const HELP_CATEGOTY_ICON_MAP = [
  {
    id: '66dac30cc263c66781ca836c',
    icon: 'icon-whats-new',
  },
  {
    id: '59818790042863033a1b904a',
    icon: 'icon-getting',
  },
  {
    id: '59949931042863033a1c0af6',
    icon: 'icon-publishing',
  },
  {
    id: '598596182c7d3a73488baa46',
    icon: 'icon-building',
  },
  {
    id: '6075aa7cf8c0ef2d98df1ce2',
    icon: 'icon-seo',
  },
  {
    id: '6075aa618af76a714bfd6a85',
    icon: 'icon-blog',
  },
  {
    id: '6075aa738996210f18bd2c59',
    icon: 'icon-online-store',
  },
];
